import { render, staticRenderFns } from "./NTable.vue?vue&type=template&id=31328e55"
import script from "./NTable.vue?vue&type=script&lang=js"
export * from "./NTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports